import { ADD_QUEUE, SET_QUEUE, SET_BUTTON_ENABLED } from './constants'

// Initial state of the store
const initialState = {
    normal: {
        name: 'normal',
        buttonEnabled: true,
        visible: true,
    },
    settings: {
        name: 'settings',
        buttonEnabled: false,
        visible: true,
    },
    active: 'normal',
}

const reducer = (state = initialState, action) => {
    const { payload, type } = action
    switch (type) {
        // Create and select a new queue
        case ADD_QUEUE: {
            return {
                ...state,
                [payload.name]: payload,
            }
        }
        // Change active queue
        case SET_QUEUE: {
            // Make sure we use normal if nothing is given
            let name = 'normal'
            if (payload != null && payload !== '') {
                name = payload
            }

            // Make sure we create the queue if it is missing
            if (state[name] == null) {
                return {
                    ...state,
                    [name]: {
                        name,
                        buttonEnabled: false,
                        visible: true,
                    },
                    active: name,
                }
            }

            return {
                ...state,
                active: name,
            }
        }

        // En/Dis-able the menu button
        case SET_BUTTON_ENABLED: {
            // We always set visibility to true. Two scenarios
            // 1. We are adding a button: The value was already true,
            //    and we are just keeping it like it was
            // 2. We are removing the button: Since there will be no button
            //    we have to make sure that visible is set to true. The user
            //    no longer can control/affect the visibility state
            return {
                ...state,
                [state.active]: {
                    name: state.active,
                    buttonEnabled: payload,
                    visible: true,
                },
            }
        }

        // Default state
        default:
            return state
    }
}

export default reducer



// WEBPACK FOOTER //
// ./src/features/Toaster/data/queue/reducers.js